import {APP_INITIALIZER, NgModule} from "@angular/core";
import {AppComponent} from "./app.component";
import {CoreModule} from "./core-module/core.module";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {AppEventBus} from "./common/event-buses/app.event-bus";
import {provideRouter} from "@angular/router";
import {routes} from "./app.routes";
import {HttpRepository} from "./common/repositories/http.repository";
import {UserTokensRepository} from "./common/repositories/user-tokens.repository";
import {GlobalConfig} from "./common/configs/GlobalConfig";
import {User} from "./common/interfaces/rest/User";
import {UserSessionRepository} from "./common/repositories/user-session.repository";
import {UserSession} from "./common/interfaces/domain/UserSession";
import {AccessControlService} from "./common/services/access-control.service";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslationRepository} from "./common/repositories/translation.repository";
import {TranslationLoader} from "./common/helpers/TranslationLoader";
import {NotFoundView} from "./common/components/not-found/_views/not-found.view";
import {AccessDeniedView} from "./common/components/access-denied/_views/access-denied.view";
import {ColumnChangesService, DimensionsHelper, ScrollbarHelper} from "@swimlane/ngx-datatable";
import {SsoRedirectView} from "./common/components/sso-redirect/_views/sso-redirect.view";

@NgModule({
  declarations: [
    AppComponent,
    NotFoundView,
    AccessDeniedView,
    SsoRedirectView,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: loadTranslationFile,
        deps: [TranslationRepository]
      }
    }),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    ScrollbarHelper,
    DimensionsHelper,
    ColumnChangesService,
    AppEventBus,
    {
      provide: APP_INITIALIZER,
      deps: [UserTokensRepository, UserSessionRepository, HttpRepository],
      multi: true,
      useFactory: initUserSession
    },
    {
      provide: APP_INITIALIZER,
      deps: [AccessControlService],
      multi: true,
      useFactory: initAppComponentScreenAccess
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}

export function initUserSession(userTokensRepository: UserTokensRepository, userSessionRepository: UserSessionRepository, httpRepository: HttpRepository) {
  return () => {
    return new Promise<void>((resolve, reject) => {
      if(userTokensRepository.getUserTokens() && userTokensRepository.getUserTokens().accessToken) {
        httpRepository.get<User>(GlobalConfig.endpoints.getCurrentUser).subscribe({
          next: (user) => {
            const userSession = userSessionRepository.createUserSession(user);
            userSessionRepository.setUserSession(userSession);

            console.log(`Initialized user session successfully`);
            resolve();
          },
          error: (error) => {
            console.log(`Failed to initialize user session`);
            resolve();
          }
        });
      }
      else {
        resolve();
      }
    });
  };
}

export function initAppComponentScreenAccess(accessControlService: AccessControlService) {
  return () => {
    return new Promise<void>((resolve, reject) => {
      accessControlService.initializeScreenAccess(AccessControlService.MAIN_APP_COMPONENT).subscribe({
        next: (result) => {
          if(!result) {
            console.log(`Failed to initialize screen access for ${AccessControlService.MAIN_APP_COMPONENT}`);
          }

          resolve();
        }
      });
    });
  };
}

export function loadTranslationFile(translationRepository: TranslationRepository) {
  return new TranslationLoader(translationRepository);
}
